export enum AutomationsTypeEnum {
  HeatingControlBasic = 'heating_control_basic',
  HeatingControlSmart = 'heating_control_smart',
  HeatingAndCoolingControlSmart = 'heating_and_cooling_control_smart',
  HeatingAndCoolingControlPremium = 'heating_and_cooling_control_premium',
}
